var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
const SplitButton = (_a) => {
    var { menuItems, onClick, children, style } = _a, rest = __rest(_a, ["menuItems", "onClick", "children", "style"]);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    return (React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(ButtonGroup, Object.assign({ ref: anchorRef, "aria-label": "split button", style: style }, rest),
                React.createElement(Button, { style: style, onClick: onClick }, children),
                React.createElement(Button, { size: "small", "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-label": "select merge strategy", "aria-haspopup": "menu", onClick: handleToggle },
                    React.createElement(ArrowDropDownIcon, null))),
            React.createElement(Popper, { open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true }, ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                } }),
                React.createElement(Paper, null,
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement(MenuList, { id: "split-button-menu" }, menuItems.map(({ props, children }, index) => {
                            const { onClick } = props, rest = __rest(props, ["onClick"]);
                            return (React.createElement(MenuItem, Object.assign({ key: index, onClick: (event) => {
                                    handleClose(event);
                                    onClick(event);
                                } }, rest), children));
                        }))))))))));
};
export default SplitButton;
